import * as moment from 'moment';
import { catchError, tap } from 'rxjs/operators';
import { filter as _filter, get as _get } from 'lodash';
import { HttpClient } from '@angular/common/http';
import { of, BehaviorSubject, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CheckApiResponse } from '../../classes/check-api-response';
import { CommonValues } from '../../classes/common-values';
import { DataService } from '../../services/data/data.service';
import { SecurityService } from '../../services/security/security.service';
var PostService = /** @class */ (function () {
    function PostService(checkApiResponse, commonValues, dataService, http, router, securityService) {
        this.checkApiResponse = checkApiResponse;
        this.commonValues = commonValues;
        this.dataService = dataService;
        this.http = http;
        this.router = router;
        this.securityService = securityService;
        this.defaultState = 'International';
        this.defaultZip = this.commonValues.defaultZip;
        this.organizationNetworkType$ = new BehaviorSubject(null);
        this.unsubscribe$ = new Subject();
    }
    PostService.prototype.saveResponse = function (json) {
        if (this.checkApiResponse.isValid(json)) {
            this.dataService.save({
                response: json
            });
        }
        else {
            throw new Error('Error found in valid response JSON');
        }
    };
    PostService.prototype.saveToken = function (token) {
        if (token) {
            this.dataService.save({
                jsonWebToken: token
            });
        }
        else {
            throw new Error('Missing JWT value');
        }
    };
    PostService.prototype.student = function () {
        var _this = this;
        var data = this.dataService.get();
        var requestor = data.form.requestor;
        var dateOfBirth = moment(requestor.personal.dob, this.commonValues.dateFormat.input).format(this.commonValues.dateFormat.output);
        var attendSchoolInfoData = requestor.attend.programs
            ? requestor.attend.programs.map(function (program) {
                return {
                    attendSchool: program.program ? _this.commonValues.api.yes : null,
                    attendSchlBeg: program.yearFrom || null,
                    attendSchlEnd: program.yearTo || null
                };
            })
            : null;
        var postData = {
            orderHeader: {
                archiveStudent: requestor.personal.enrolledBefore || this.commonValues.api.no,
                feePathTypeAnswer: requestor.personal.path,
                integrationHoldActivityId: _get(data.studentProfile, 'integrationHoldActivityId', null),
                toScprofilId: this.dataService.get().schoolProfile.toScprofilId,
                referMethod: this.getReferMethod(),
                feePathType: (this.dataService.postAuthorizationData &&
                    this.dataService.postAuthorizationData.feepathType === this.commonValues.api.free) ? this.commonValues.api.free : (this.dataService.postAuthorizationData &&
                    this.dataService.postAuthorizationData.feepathType === this.commonValues.api.pay) ? this.commonValues.api.pay : null,
            },
            student: {
                attendBeginYear: requestor.personal.enrolledYearFrom,
                toScCampusId: requestor.personal.campus,
                toScCampusName: null,
                attendSchoolInfo: attendSchoolInfoData,
                attendEndYear: requestor.personal.enrolledYearTo,
                city: requestor.contact.city,
                country: requestor.contact.country,
                currEnrolled: requestor.personal.enrolledCurrently,
                zeroFeePrgmCurrEnroll: requestor.personal.zeroFeePrgmCurrEnroll,
                dateOfBirth: dateOfBirth,
                degreeInfo: [
                    {
                        degreeTitle: requestor.attend.degree1,
                        awardYear: requestor.attend.year1
                    },
                    {
                        degreeTitle: requestor.attend.degree2,
                        awardYear: requestor.attend.year2
                    },
                    {
                        degreeTitle: requestor.attend.degree3,
                        awardYear: requestor.attend.year3
                    },
                    {
                        degreeTitle: requestor.attend.degree4,
                        awardYear: requestor.attend.year4
                    }
                ],
                email: requestor.contact.emailPrimary,
                firstName: requestor.personal.nameFirst,
                lastName: requestor.personal.nameLast,
                middleName: requestor.personal.nameMiddle,
                phone: requestor.contact.phone,
                schlFirstName: requestor.personal.nameChangedFirst,
                schlLastName: requestor.personal.nameChangedLast,
                schlMiddleName: requestor.personal.nameChangedMiddle,
                ssn: (requestor.personal.ssnPrimary ? requestor.personal.ssnPrimary.replace(/-/g, '') : null)
                    || ((this.dataService.postAuthorizationData
                        && (this.dataService.postAuthorizationData.appType === this.commonValues.applicationType.studentSelfService || this.dataService.postAuthorizationData.appType === this.commonValues.applicationType.saml)
                        && this.dataService.postAuthorizationData.ssn) ? this.dataService.postAuthorizationData.ssn : null),
                state: requestor.contact.state || this.defaultState,
                street1: requestor.contact.addressLine1,
                street2: requestor.contact.addressLine2,
                studentId: (requestor.personal.studentIdPrimary ? requestor.personal.studentIdPrimary.replace(/-/g, '') : null)
                    || ((this.dataService.postAuthorizationData
                        && (this.dataService.postAuthorizationData.appType === this.commonValues.applicationType.studentSelfService || this.dataService.postAuthorizationData.appType === this.commonValues.applicationType.saml)
                        && this.dataService.postAuthorizationData.collegeStudentId) ? this.dataService.postAuthorizationData.collegeStudentId : null),
                textMessging: {
                    mobilePhoneNumber: requestor.contact.textUpdates === this.commonValues.api.yesSMS
                        ? (requestor.contact.phone.replace(/[-]+/g, ''))
                        : null,
                    sendTxtMsg: requestor.contact.textUpdates
                },
                updateSchoolRec: requestor.contact.updateRecords,
                verifiedStudentId: _get(data.studentProfile, 'verifiedStudentId', null),
                zip: requestor.contact.zip || this.defaultZip
            }
        };
        // cf. https://angular.io/guide/http#reading-the-full-response
        // need the full response on this request so we can access the headers, and save the JWT value;
        // the JWT value will be used on subsequent API calls;
        return this.http.post('/api/tsorder/order', postData, { observe: 'response' }).pipe(tap(function (resp) {
            _this.saveToken(resp.headers.get('authorization-token'));
            _this.saveResponse(resp.body);
        }), catchError(function (error) { return _this.securityService.catchResponse(error); }));
    };
    PostService.prototype.getReferMethod = function () {
        var postAuthorizationData = this.dataService.postAuthorizationData;
        var referMethod = null;
        if (postAuthorizationData && postAuthorizationData.appType) {
            switch (postAuthorizationData.appType) {
                case this.commonValues.applicationType.studentSelfService:
                    referMethod = 'S';
                    break;
                case this.commonValues.applicationType.myHub:
                    referMethod = 'H';
                    break;
                case this.commonValues.applicationType.saml:
                    referMethod = 'O';
                    break;
                default:
                    break;
            }
        }
        return referMethod;
    };
    PostService.prototype.getAttachments = function (recipient) {
        var uploadedFiles = [];
        Array.from(recipient.attachments).forEach(function (uploadedFile, index) {
            if (uploadedFile.attachmentResponse && uploadedFile.attachmentResponse.status === 'success') {
                var tempAttachment = {
                    fileIdentifier: uploadedFile.attachmentResponse.fileIdentifier,
                    originalFileName: uploadedFile.attachmentResponse.originalFileName,
                    contentType: uploadedFile.attachmentResponse.contentType
                };
                uploadedFiles.push(tempAttachment);
            }
        });
        return (uploadedFiles.length > 0) ? uploadedFiles : null;
    };
    PostService.prototype.getRecipientEmail = function (recipient) {
        if (recipient.who.sendElectronically === this.commonValues.api.yes) {
            // set recipient email to the one entered on the recipient/select page if the user answered yes to send electronically
            // regardless if there was a match or not, this allows us to reuse the email and avoid going to delivery info page
            return recipient.who.emailPrimary;
        }
        return recipient.address.emailPrimary;
    };
    PostService.prototype.recipients = function () {
        var _this = this;
        var data = this.dataService.get();
        var orderId = this.dataService.get().response.orderHeader.toOrderId;
        var formRecipients = this.dataService.get().form.recipients;
        var postData = [];
        var mailDeliveryMethods = [
            this.commonValues.api.mail,
            this.commonValues.api.faxExpress,
            this.commonValues.api.overnight,
            this.commonValues.api.faxMail
        ];
        var isNullsubNetworkFormField;
        var _loop_1 = function (index) {
            var deliveryMethod = null;
            var recipient = formRecipients[index];
            if (!this_1.dataService.isNullorBlank(recipient.delivery.zeroFeeProgramEligible) && recipient.delivery.zeroFeeProgramEligible === 'Y') {
                // if zero fee program is eligible then get deliverymethod, transcript and quantity from zero pay or free options
                deliveryMethod = this_1.dataService.getZeroFeeDeliveryMethodObject(recipient.delivery.deliveryMethod);
            }
            else {
                deliveryMethod = this_1.dataService.getDeliveryMethodObject(recipient.delivery.deliveryMethod);
            }
            // determine which value to return for State and ZIP;
            // if the user didn't enter a value, we are to pass the defined value - for certain delivery methods;
            var deliveryMethodType = deliveryMethod.deliveryMethodType;
            var defaultState = mailDeliveryMethods.indexOf(deliveryMethodType) > -1 ? this_1.defaultState : null;
            var defaultZip = mailDeliveryMethods.indexOf(deliveryMethodType) > -1 ? this_1.defaultZip : null;
            // return either the department or subnetwork object (both are the same);
            // otherwise an empty object for _get() to find nothing in;
            var getDepartment = function () {
                var departments = _get(recipient.who, 'recipientResponse.recipientDepartments', []);
                var recipientResponseDepartment = _filter(departments, {
                    deptId: recipient.who.department
                });
                return recipientResponseDepartment.length ? recipientResponseDepartment[0] : null;
            };
            var getSubNetwork = function () {
                return _get(recipient.who, 'recipientResponse.subNetwork', null);
            };
            var getExchangeChanel = function () {
                if ((recipient.who.oborDeliveryEligibility !== null && recipient.who.oborDeliveryEligibility === _this.commonValues.api.yes) || (recipient.who.recipientResponse && (recipient.who.recipientResponse.exchangeNetworkType === _this.commonValues.api.speede || recipient.who.recipientResponse.exchangeNetworkType === _this.commonValues.api.fast))) {
                    return _get(recipient.who, 'recipientResponse.exchangeChanel', null);
                }
            };
            var getExchangeDataObject = function () {
                return getDepartment() || getSubNetwork() || getExchangeChanel();
            };
            var getSPDEZeroFeePrgmEligible = function () {
                var exchangeNetworkType = _get(recipient.who.recipientResponse, 'exchangeNetworkType', null);
                return _this.dataService.getSPDEZeroFeeEligibilityByNetworkCode(exchangeNetworkType);
            };
            var exchangeNetworkType = recipient.who.recipientResponse ? recipient.who.recipientResponse.exchangeNetworkType : null;
            var orderProcessFeePaidBy = this_1.dataService.getOrderProcessFeePaidByValue(recipient.delivery.deliveryMethod, exchangeNetworkType);
            // if the recipient isn't defined in the form data model, then the address fields were skipped, and recipient was never set;
            // if that's the case, then get the value here (pass in the index so the getRecipient() knows which array item to reference);
            // this will happen with ETX recipients;
            var attentionField = (recipient.who.recipientResponse && (recipient.who.recipientResponse.exchangeNetworkType === this_1.commonValues.api.obor || recipient.who.recipientResponse.exchangeNetworkType === this_1.commonValues.api.speede || recipient.who.recipientResponse.exchangeNetworkType === this_1.commonValues.api.fast));
            var organization = recipient.address.recipient || this_1.dataService.getRecipient(index);
            var recipientResponse = (recipient.who.oborDeliveryEligibility !== null && recipient.who.oborDeliveryEligibility === this_1.commonValues.api.yes) ? null : recipient.who.matchedUboxEntry;
            var deptRecipientId = (recipientResponse ? recipientResponse.etxDeptId : null);
            var isSPDEZeroPrgmEligible = getSPDEZeroFeePrgmEligible();
            var recipientItem = {
                amcasId: recipient.who.aamcAccountNumber,
                amcasTranscriptId: recipient.who.amcasTranscriptIdNumber,
                attachments: this_1.getAttachments(recipient),
                attention: recipient.address.attention || (attentionField ? null : _get(getExchangeDataObject(), 'deptName', null)),
                city: recipient.address.city,
                country: recipient.address.country,
                degreeTitle: (this_1.dataService.isSchoolEllucian() === false) ? recipient.delivery.degreeTitle : recipient.delivery.program,
                deliveryMethodId: recipient.delivery.deliveryMethod,
                deptProcessingOption: _get(getExchangeDataObject(), 'subNetworkType', null),
                email: this_1.getRecipientEmail(recipient),
                etxDeliveryFileFormat: recipientResponse ? recipientResponse.fileFormat : _get(getExchangeDataObject(), 'fileFormat', null),
                etxDeptRecipientId: deptRecipientId ? deptRecipientId : _get(getExchangeDataObject(), 'ftpAccountName', null),
                exchangeNetworkTypeCode: _get(recipient.who.recipientResponse, 'exchangeNetworkType', null),
                etxRgtryUboxId: (recipient.who.matchedUboxEntry) ? recipient.who.matchedUboxEntry.etxRgtryUboxId : null,
                sendToSchoolElectronic: (recipient.who.sendElectronically) ? recipient.who.sendElectronically : null,
                ficeCode: recipient.who.recipientFiceCode,
                feeReduceEligible: isSPDEZeroPrgmEligible ? recipient.delivery.zeroFeeProgramEligible : null,
                isVerifiedAddress: recipient.address.isVerifiedAddress,
                isAckgInvalidAddress: recipient.address.isAckgInvalidAddress,
                liaisonCasId: recipient.who.casId,
                lsacId: recipient.who.lsacAccountNumber,
                oborDeliveryEligibility: recipient.who.oborDeliveryEligibility ? recipient.who.oborDeliveryEligibility : null,
                organization: organization,
                phone: recipient.address.phone,
                processingOption: recipient.delivery.transcriptWhen,
                quantityId: recipient.delivery.howMany,
                sendToType: recipient.who.recipientType,
                specialInstr: recipient.delivery.specialInstructions,
                state: recipient.address.state || defaultState,
                street1: recipient.address.addressLine1,
                street2: recipient.address.addressLine2,
                term: (this_1.dataService.isSchoolEllucian() === false) ? recipient.delivery.term : recipient.delivery.ungradedTerm,
                year: recipient.delivery.year,
                courseName1: recipient.delivery.course1,
                courseName2: recipient.delivery.course2,
                toOrderId: orderId,
                xcriptPurposeId: recipient.delivery.transcriptPurpose,
                xcriptTypeId: recipient.delivery.transcriptType,
                zip: recipient.address.zip || defaultZip,
                isZeroFeePrgrmEligible: (!isSPDEZeroPrgmEligible && recipient.delivery.zeroFeeProgramEligible) ? recipient.delivery.zeroFeeProgramEligible : null,
                zeroFeePrgmId: (recipient.delivery.zeroFeeProgramEligible === 'Y' && recipient.who.recipientResponse.zeroFeePrgmId) ? recipient.who.recipientResponse.zeroFeePrgmId : null,
                enteredAddressLine1: recipient.address.enteredAddressLine1,
                enteredAddressLine2: recipient.address.enteredAddressLine2,
                recievingFileFormat: recipientResponse ? recipientResponse.recievingFileFormat : _get(getExchangeDataObject(), 'recievingFileFormat', null),
                allowDataConvert: ((recipientResponse && recipientResponse.recievingFileFormat) ? 'Y' : null) || (_get(getExchangeDataObject(), 'recievingFileFormat', null) ? 'Y' : null),
                orderProcessFeePaidBy: orderProcessFeePaidBy
            };
            // for LSAC, AMCAS, LIASON org  we need to verify that ID's are present otherwise stop the processs and request to enter again.
            isNullsubNetworkFormField = this_1.verifyNotNullOrganizationId(recipient.who);
            if (isNullsubNetworkFormField) {
                this_1.organizationNetworkType$.next(index);
                return "break";
            }
            postData.push(recipientItem);
        };
        var this_1 = this;
        // loop through the entered recipients to create the payload to send to the API;
        for (var index = 0; index < formRecipients.length; index++) {
            var state_1 = _loop_1(index);
            if (state_1 === "break")
                break;
        }
        // if organizationId is required and is null then stop the process and show error popup
        if (isNullsubNetworkFormField) {
            return of(null);
        }
        else {
            var orderId_1 = this.dataService.get().response.orderHeader.toOrderId;
            return this.http.post("/api/tsorder/order/" + orderId_1 + "/recipients", postData).pipe(tap(function (json) { return _this.saveResponse(json); }), catchError(function (error) { return _this.securityService.catchResponse(error); }));
        }
    };
    PostService.prototype.verifyNotNullOrganizationId = function (item) {
        var recipient = item.recipientResponse && item.recipientResponse.subNetwork && item.recipientResponse.subNetwork.subNetworkType;
        var subNetworkType = recipient ? item.recipientResponse.subNetwork.subNetworkType : null;
        if (subNetworkType && (subNetworkType === this.commonValues.api.amcas || subNetworkType === this.commonValues.api.lsac || subNetworkType === this.commonValues.api.liason)) {
            // if the value is null then needs to redirect to recipient Select page
            var recipientValue = null;
            switch (subNetworkType) {
                case this.commonValues.api.amcas:
                    recipientValue = item.aamcAccountNumber;
                    break;
                case this.commonValues.api.lsac:
                    recipientValue = item.lsacAccountNumber;
                    break;
                case this.commonValues.api.liason:
                    recipientValue = item.casId;
                    break;
            }
            if (!recipientValue) {
                return true;
            }
        }
        return null;
    };
    PostService.prototype.payment = function () {
        var _this = this;
        var orderId = this.dataService.get().response.orderHeader.toOrderId;
        var payment = this.dataService.get().form.payment;
        var postData = {
            billCity: payment.city,
            billCountry: payment.country,
            billPhone: null,
            billState: payment.state,
            billStreet1: payment.addressLine1,
            billStreet2: payment.addressLine2,
            billZip: payment.zip,
            ccAmount: this.dataService.get().response.orderHeader.totalFee,
            ccExpiryMonth: payment.expirationMonth,
            ccExpiryYear: "20" + payment.expirationYear,
            ccName: payment.name,
            ccType: payment.ccType,
            payeezyToken: payment.payeezyToken
        };
        return this.http.post("/api/tsorder/order/" + orderId + "/payment", postData).pipe(tap(function (json) { return _this.saveResponse(json); }));
    };
    PostService.prototype.consent = function () {
        var _this = this;
        var orderId = this.dataService.get().response.orderHeader.toOrderId;
        var postData = {
            lines: this.dataService.get().form.consent.signature.lines
        };
        return this.http.post("/api/tsorder/order/" + orderId + "/consent-signature", postData).pipe(tap(function (json) { return _this.saveResponse(json); })
        // handle the error at component level
        // catchError(error => this.securityService.catchResponse(error))
        );
    };
    return PostService;
}());
export { PostService };
